import React from 'react';
import { ArrowUpRight } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { getText } from '../../utils/language';
import { useI18n } from '../../i18n';

const ArtCard = ({ art, index = 0, language = 'en' }) => {
  const { t } = useI18n();
  const displayTitle = getText(art.title, language, 'Untitled');
  const arabicTitle = typeof art.title === 'object' ? art.title.ar : '';
  const displayImage = Array.isArray(art.images) && art.images.length > 0 ? art.images[0] : null;
  const imageHeight = index % 3 === 1 ? 'h-[430px]' : index % 3 === 2 ? 'h-[360px]' : 'h-[395px]';

  return (
    <article className="group min-w-0">
      <Link to={`/gallery/artwork/${art._id}`} className="block focus:outline-none">
        <div className={`relative overflow-hidden bg-surface ${imageHeight}`}>
          {displayImage ? (
            <img
              src={displayImage}
              alt={displayTitle}
              className="h-full w-full object-cover object-center transition duration-700 ease-out group-hover:scale-[1.025] group-hover:saturate-100"
              loading={index > 2 ? 'lazy' : 'eager'}
            />
          ) : (
            <div className="grid h-full place-items-center border border-border text-sm text-text-muted">No image</div>
          )}
          <span className="absolute bottom-4 right-4 grid h-11 w-11 translate-y-2 place-items-center rounded-full bg-surface text-text-primary opacity-0 shadow-lg transition duration-300 group-hover:translate-y-0 group-hover:opacity-100">
            <ArrowUpRight size={20} />
          </span>
        </div>

        <div className="grid grid-cols-[1fr_auto] gap-4 border-t border-border py-4">
          <div className="min-w-0">
            <span className="editorial-eyebrow block text-[10px]">{art.category || t('common.original')}</span>
            <h2 className="mt-1 font-display text-2xl font-semibold leading-none text-text-primary">{displayTitle}</h2>
            {arabicTitle && language !== 'ar' && <p className="mt-1 font-arabic text-lg leading-relaxed text-text-secondary" dir="rtl" lang="ar">{arabicTitle}</p>}
          </div>
          <span className="self-start whitespace-nowrap pt-5 text-xs font-medium text-text-secondary">{t('gallery.enter')}</span>
        </div>
      </Link>
    </article>
  );
};

export default ArtCard;
